// 기기 안 OCR(decisions): 캡처 이미지에서 대화 텍스트를 읽어낸다. 서버로 이미지를 보내지 않는다.
// Tesseract.js를 CDN에서 지연 로드한다(번들 비대화 방지, 실제 추론은 브라우저=기기에서).
let tess: any = null

function loadScript(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve()
    const s = document.createElement('script')
    s.src = src; s.onload = () => resolve(); s.onerror = () => reject(new Error('load fail: ' + src))
    document.head.appendChild(s)
  })
}

/** 이미지(dataURL/Blob URL)에서 한국어+영어 텍스트를 읽어낸다. 첫 호출은 언어 데이터를 받느라 느리다. */
export async function ocrImage(image: string, onProgress?: (p: number) => void): Promise<string> {
  if (!tess) {
    await loadScript('https://cdn.jsdelivr.net/npm/tesseract.js@5/dist/tesseract.min.js')
    tess = (window as any).Tesseract
  }
  const res = await tess.recognize(image, 'kor+eng', onProgress ? { logger: (m: any) => m.status === 'recognizing text' && onProgress(m.progress) } : {})
  return String(res?.data?.text || '').replace(/\n{3,}/g, '\n\n').trim()
}
